import { Injectable, inject, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { formatApiErrorMessage } from '../errors/errormessage.service';

@Injectable({
  providedIn: 'root'
})
export class ToastMessageService {
  private readonly injector = inject(Injector);
  private readonly translateService = inject(TranslateService);
  private _messageService?: MessageService;
  
  // Lazy-inject and cache MessageService to handle components with appendTo="body"
  private get messageService(): MessageService {
    if (!this._messageService) {
      this._messageService = this.injector.get(MessageService);
    }
    return this._messageService;
  }


  showSuccess(message: string, life:number = 3000) {
    this.messageService.add({  key:"main",severity: 'success', summary: 'Success', detail: message , life:life});
  }

  showError(error: any, life:number = 3000, key:string = 'main') {
    if (error?.originalError?.status === 403) {
      this.translateService.get('common.errors.validations.FORBIDDEN')
      .subscribe((translation) => {
        this.messageService.add({
          key:key,
          severity: 'error',
          summary: 'Error',
          detail: translation,
          life:life
        });
      });
    }
    else if (error?.originalError?.status === 404) {
      this.translateService.get('common.errors.validations.NOTFOUND')
      .subscribe((translation) => {
        this.messageService.add({
          key:key,
          severity: 'error',
          summary: 'Error',
          detail: translation,
          life:life
        });
      });
    }
    else if(error?.originalError?.status == 200)
    {
        this.messageService.add({
          key:key,
          severity: 'success',
          summary: 'Success',
          detail: error?.originalError?.error?.text,
          life:life
        });
    }
    else if(error?.originalError?.status == 500)
    {
      this.translateService.get('common.errors.SERVER_SIDE.SOMETHING_WRONG')
      .subscribe((translation) => {
        this.messageService.add({
          key:key,
          severity: 'error',
          summary: 'Error',
          detail: translation,
          life:life
        });
      });
    }
    else{
      if(Array.isArray(error?.originalError?.error))
      {
        error.originalError.error.forEach((e: any) => {
          this.messageService.add({
            key:key,
            severity: 'error',
            summary: 'Error',
            detail: formatApiErrorMessage(e?.errorMessage) ?? e?.errorMessage,
            life:life
          });
        });
      }
      else if (typeof error?.originalError?.error === 'string') {
        if(error?.originalError?.error?.errorMessage)
        {
          this.messageService.add({
            key:key,
            severity: 'error',
            summary: 'Error',
            detail: formatApiErrorMessage(error?.originalError?.error?.errorMessage) ?? error?.originalError?.error?.errorMessage,
            life:life
          });
        }
        else{
          this.messageService.add({
            key:key,
            severity: 'error',
            summary: 'Error',
            detail: formatApiErrorMessage(error?.originalError?.error) ?? error?.originalError?.error,
            life:life
          });
        }
      }
      else{
        this.messageService.add({
          key:key,
          severity: 'error',
          summary: 'Error',
          detail: formatApiErrorMessage(error?.originalError?.error?.errorMessage) ?? error?.originalError?.error?.errorMessage,
          life:life
        });
      }
    }
  }

  showInfo(message: string, life:number = 3000) {
    this.messageService.add({  key:"main", severity: 'info', summary: 'Info', detail: message , life:life});
  }

  showWarning(message: string, life:number = 3000, key:string = 'main') {
    this.messageService.add({  key:key, severity: 'warn', summary: 'Warning', detail: message , life:life});
  }

  showCustomWarning(message: string,key:string,data:any, life:number = 3000) {
    this.messageService.add({  key:key, severity: 'warn', summary: 'Warning', detail: message , life:life, data:data});
  }


  showErrorMessage(message: string, life:number = 3000) {
    this.messageService.add({  key:"main", severity: 'error', summary: 'Error', detail: message , life:life});
  }

  showCustomSuccess(summary:string,message: string, life:number = 3000) {
    this.messageService.add({  key:"main",severity: 'success', summary: summary, detail: message , life:life});
  }

  showSuccessWithData(message: string,data:any, life:number = 3000) {
    this.messageService.add({  key:"main",severity: 'success', summary: 'Success', detail: message,data:data , life:life});
  }

  clearMessage(key:string) {
    this.messageService.clear(key);
  }
  
}
